import {BasicCriteria} from './BasicCriteria';
import {BasicEntity} from '../message/BasicEntity';
import {BasicScenario} from './BasicScenario';

export class BaseWrapper <T extends BasicEntity, CRIT extends BasicCriteria, SCEN extends BasicScenario> {
criteria: CRIT;
entities: T[];
entity: T;
errorCode: string;
method: string;
scenario: SCEN;
status: string;
}

